<template>
  <div class="activity">
    <div class="boxCenter">
      <div class="insideBanner">
        <img :src="bannerImg" alt="TINDOE坦途"/>
        <!--<div class="title">活动专区</div>-->
        <div class="searchBox">
          <input placeholder="请输入目的地/景点" v-model="key"/>
          <span class="btn" @click="loadActivitiesList"></span>
        </div>
      </div>

      <div class="baseActivities">
        <div class="classBox">
          <span v-for="(item,index) in travelTypeList" :key="index" class="item" :class="{'active':item.selected}" @click="switchTraveType(item)">{{item.name}}</span>
        </div>
        <div class="filterBox">
          <span class="fth">活动主题：</span>
          <span class="ftd" v-for="(item,index) in activityThemeList" :key="index"><a :class="{'active':item.selected}" @click="switchActivityTheme(item)">{{item.name}}</a></span>
        </div>
        <div class="filterBox">
          <span class="fth">活动价格：</span>
          <span class="ftd" v-for="(item,index) in priceList" :key="index"><a :class="{'active':item.selected}" @click="switchPrice(item)">{{item.name}}</a></span>
        </div>
        <div class="filterBox">
          <span class="fth">出行日期：</span>
          <span class="ftd"><a :class="{'active':selectAllTime}" @click="selectTimeAll">全部</a></span>
          <el-date-picker
            v-model="timeValue"
            @change="timeChange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            size="mini"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
      </div>

      <div class="baseList">
        <ul v-if="travelList.length > 0">
          <li class="baseActiveLi" v-for="(item,index) in travelList" :key="index">
            <div class="imgBox">
              <router-link  :to="'/activitieDetails/'+item.id"><img :src="item.pic" alt="TINDOE坦途"/></router-link>
              <div class="slogin">{{item.themName}} | {{item.startLocation}}{{item.classify == 1 ? '' : '出发'}}</div>
            </div>
            <div class="infoBox">
              <div class="title"><span>{{item.typeName}}</span> &nbsp;&nbsp;{{item.name}}</div>
              <div class="des">{{item.intro}}</div>
              <div class="days">活动周期：<span>{{item.cycle}}</span></div>
              <div class="price"><span class="span1">¥</span>{{item.childPrice > 0 ? item.childPrice.toFixed(2) : item.price.toFixed(2)}}<span class="span2">元起</span></div>
              <div class="signUp"><span>{{item.signUp}}</span>人已报名<router-link :to="'/activitieDetails/'+item.id">立刻报名</router-link></div>
            </div>
          </li>
        </ul>
        <div v-else>
          <p style="text-align: center;padding-top: 50px;">暂无相关数据...</p>
        </div>
      </div>

      <div style="padding:100px;text-align: center">
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :current-page="curPage"
          :page-size="10"
          :total="totalNews">
        </el-pagination>
      </div>

      <div class="newList">
        <div class="title">推荐活动</div>
        <ul>
          <li v-for="(item,index) in RecommendPlaceList" :key="index">
            <router-link :to="'/activitieDetails/'+item.id">
            <img :src="item.pic" alt="TINDOE坦途"/>
            </router-link>
            <div class="slogin">{{item.themName}} | {{item.startLocation}} {{item.classify == 1 ? '' : '出发'}}</div>
            <div class="info">
              <div class="des">{{item.name}}</div>
              <div class="price">
                <p>{{item.signUp}}人已报名</p>
                <p><span class="span1">¥</span>{{item.childPrice > 0 ? item.childPrice.toFixed(2) : item.price.toFixed(2)}}<span class="span2">元起</span></p>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <el-dialog width="460px" title="请用微信扫描下方小程序码报名" :visible.sync="dialogTableVisible">
        <div style="text-align:center"><img :src="signCode" alt="TINDOE坦途"/></div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return {
        dialogTableVisible:false,
        curPage:1,
        totalNews:0,
        signCode:'',
        activityThemeList:[ //活动主题列表
          {
            id:'',
            name:'全部',
            selected:true
          }
        ],
        curActivityTheme:'',
        priceList:[       //活动价格列表
          {
            startPrice:'',
            endPrice:'',
            name:'全部',
            selected:true
          },
          {
            startPrice:'1',
            endPrice:'99',
            name:'1-99',
            selected:false
          },
          {
            startPrice:'100',
            endPrice:'499',
            name:'100-499',
            selected:false
          },
          {
            startPrice:'500',
            endPrice:'999',
            name:'500-999',
            selected:false
          },
          {
            startPrice:'1000',
            endPrice:'4999',
            name:'1000-4999',
            selected:false
          },
          {
            startPrice:'5000',
            endPrice:'',
            name:'5000以上',
            selected:false
          },
        ],
        curPrice:{
          startPrice:'',
          endPrice:''
        },
        travelTypeList:[
          {
            id:'',
            name:'全部',
            selected:true
          }
        ], //活动类型列表
        curTravelType:'',
        timeValue:[], //出行日期
        startDate:'',
        endDate:'',
        selectAllTime:true,
        key:'',
        travelList:[],
        RecommendPlaceList:[],
        bannerImg:''
      }
    },
    computed:{

    },
    mounted(){
      if(this.$route.params.id){
        this.curTravelType = this.$route.params.id
      }
      Date.prototype.format = function (fmt) {
        let o = {
          "M+": this.getMonth() + 1, //月份
          "d+": this.getDate(), //日
          "h+": this.getHours(), //小时
          "m+": this.getMinutes(), //分
          "s+": this.getSeconds(), //秒
          "q+": Math.floor((this.getMonth() + 3) / 3), //季度
          "S": this.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
          if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
      }
      this.loadThemeList()
      this.loadTravelTypeList()
      this.loadActivitiesList()
      this.loadRecommendPlace()
      this.loadBanner()
    },
    methods:{
      loadBanner(){
        this.$https.get('/api/config').then((response)=>{
          this.dataObj = response.data
          for(let i=0;i<response.data.length;i++){
            let item = response.data[i]
            if(item.id == 9){
              this.bannerImg = item.msg
              break
            }
          }
        }).catch((error) => {

        });
      },
      handleCurrentChange(val){
        this.curPage = val
        this.loadActivitiesList()
      },

      //立即报名
      signUpNow(item){
        this.signCode = 'http://www.tindoe.com/apiserver/api/deCode/id/' + item.id
        this.dialogTableVisible = true
      },

      //获取活动列表
      loadActivitiesList(){
        this.$https.get('/api/travel/pageIndex/'+this.curPage+'/pageNum/10?name='+this.key+'&typeId='+this.curTravelType+'&themId='+this.curActivityTheme
          +'&startPrice='+this.curPrice.startPrice+'&endPrice='+this.curPrice.endPrice+'&startDate='+this.startDate+'&endDate='+this.endDate).then((response)=>{
          this.travelList = response.data.records
          this.totalNews = response.data.total
        });
      },
      //选择所有时间
      selectTimeAll(){
        this.selectAllTime = true
        this.timeValue = []
        this.startDate = ''
        this.endDate = ''
        this.loadActivitiesList()
      },
      //选择特定时间
      timeChange(){
        this.selectAllTime = false
        this.startDate = this.timeValue[0].format("yyyy-MM-dd")
        this.endDate = this.timeValue[1].format("yyyy-MM-dd")
        this.loadActivitiesList()
      },
      //获取主题列表
      loadThemeList(){
        this.$https.get('/api/travelThem').then((response)=>{
          response.data.forEach((item)=>{
            item.selected = false
          })
          this.activityThemeList.push(...response.data)
        });
      },
      //获取分类列表
      loadTravelTypeList(){
        this.$https.get('/api/travelType').then((response)=>{
          response.data.forEach((item)=>{
            item.selected = false
            if(item.id == this.curTravelType){
              item.selected = true
              this.travelTypeList[0].selected = false
            }
          })
          this.travelTypeList.push(...response.data)
        });
      },
      //获取推荐活动列表
      loadRecommendPlace(){
        this.$https.get('/api/travel/count/6').then((response)=>{
          this.RecommendPlaceList = response.data
        }).catch((error) => {

        });
      },
      //切换活动类型
      switchTraveType(item){
        this.travelTypeList.forEach((row)=>{
          row.selected = false
        })
        item.selected = true
        this.curTravelType = item.id
        this.loadActivitiesList()
      },
      //活动主题切换
      switchActivityTheme(item){
        this.activityThemeList.forEach((row)=>{
          row.selected = false
        })
        item.selected = true
        this.curActivityTheme = item.id
        this.loadActivitiesList()
      },
      //价格切换
      switchPrice(item){
        this.priceList.forEach((row)=>{
          row.selected = false
        })
        item.selected = true
        this.curPrice.startPrice = item.startPrice
        this.curPrice.endPrice = item.endPrice
        this.loadActivitiesList()
      }
    }
  }
</script>

<style scoped>
  .activity{
    background: #fafafa;
  }
  .insideBanner{
    width: 1200px;
    height: 275px;
    position: relative;
  }
  .insideBanner .title{
    font-size: 48px;
    color: #ffffff;
    width: 100%;
    text-align: center;
    left: 0px;
    top: 80px;
    position: absolute;
  }
  .insideBanner .searchBox{
    width: 418px;
    height: 45px;
    padding-left: 62px;
    background: url("../assets/images/search-icon.png") #ffffff 13px 8px no-repeat;
    border-radius: 4px;
    position: absolute;
    top: 157px;
    left: 50%;
    margin-left: -240px;
  }
  .insideBanner .searchBox input{
    width: 100%;
    height: 45px;
    border: 0px;
    padding: 0px;
    outline: none;
    font-size: 14px;
  }
  .insideBanner .searchBox .btn{
    display: block;
    width: 39px;
    height: 39px;
    background: url("../assets/images/search-icon1.png") no-repeat;
    cursor: pointer;
    position: absolute;
    top: 3px;
    right: 3px;
    cursor: pointer;
  }
  .insideBanner img{
    width: 100%;
    height: 100%;
  }
  .baseActivities{
    margin-top: 12px;
    background: #ffffff;
  }
  .baseActivities .classBox{
    height: 62px;
    border-bottom: 1px solid #e5e5e5;
    padding: 0 3px;
  }
  .baseActivities .classBox .item{
    float: left;
    height: 30px;
    line-height: 30px;
    padding: 0 10px;
    font-size: 15px;
    color: #363636;
    border-radius: 3px;
    margin: 23px 21px 0;
    cursor: pointer;
  }
  .baseActivities .classBox .item.active{
    background: #5680f9;
    color: #ffffff;
  }
  .baseActivities .filterBox{
    margin: 0 10px;
    border-bottom: 1px dashed #e5e5e5;
    height: 42px;
    padding-top: 13px;
    line-height: 42px;
  }
  .baseActivities .filterBox .fth{
    float: left;
    width: 107px;
    text-align: center;
    font-size: 13px;
    color: #919191;
    padding-right: 28px;
  }
  .baseActivities .filterBox .ftd{
    float: left;
    min-width: 90px;
  }
  .baseActivities .filterBox .ftd a{
    display: inline-block;
    height: 21px;
    line-height: 21px;
    padding: 0 8px;
    font-size: 13px;
    color: #363636;
    cursor: pointer;
    border-radius: 3px;
  }
  .baseActivities .filterBox .ftd a.active{
    background: #5680f9;
    color: #ffffff;
  }
  .baseList{
    margin-top: 10px;
  }
  .baseActiveLi{
    height: 258px;
    background: #ffffff;
    box-shadow:0px 2px 4px 0px rgba(0,0,0,0.05);
    margin-bottom: 10px;
  }
  .baseActiveLi .imgBox{
    float: left;
    width: 480px;
    height: 258px;
    position: relative;
  }
  .baseActiveLi .imgBox img{
    width: 100%;
    height: 100%;
  }
  .baseActiveLi .imgBox .slogin{
    position: absolute;
    top: 11px;
    left: 11px;
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    color: #ffffff;
    border-radius: 32px;
    padding: 0 18px;
    background: rgba(0,0,0,0.5);
  }
  .baseActiveLi .infoBox{
    width: 692px;
    padding-left: 28px;
    height: 258px;
    float: left;
    position: relative;
  }
  .baseActiveLi .infoBox .title{
    max-height: 90px;
    line-height: 30px;
    font-size: 16px;
    font-weight: bold;
  }
  .baseActiveLi .infoBox .title span{
    float: left;
    font-weight: normal;
    line-height: 28px;
    padding: 0 10px;
    background: #ffcd30;
    color: #ffffff;
    font-size: 14px;
    border-radius: 3px;
  }
  .baseActiveLi .infoBox .des{
    height: 69px;
    line-height: 23px;
    overflow:hidden;
    text-overflow: ellipsis;
    color: #fe5a43;
    font-size: 14px;
    padding-right:20px;
  }
  .baseActiveLi .infoBox .days{
    height: 31px;
    line-height: 31px;
    font-size: 13px;
    color: #363636;
  }
  .baseActiveLi .infoBox .days span{
    font-weight: bold;
  }
  .baseActiveLi .infoBox .price{
    height: 57px;
    line-height: 57px;
    font-size: 32px;
    color: #ffcd30;
    position:absolute;
    left: 28px;
    bottom: 10px;
  }
  .baseActiveLi .infoBox .price .span1{
    font-size: 18px;
    margin-right: 4px;
  }
  .baseActiveLi .infoBox .price .span2{
    font-size: 16px;
  }
  .baseActiveLi .infoBox .signUp{
    position: absolute;
    right: 0px;
    bottom: 0px;
    line-height: 47px;
    font-size: 13px;
    color: #363636;
  }
  .baseActiveLi .infoBox .signUp span{
    font-weight: bold;
  }
  .baseActiveLi .infoBox .signUp a{
    float: right;
    width: 169px;
    height: 47px;
    text-align: center;
    line-height: 47px;
    background: #5680f9;
    color: #ffffff;
    font-size: 20px;
    cursor: pointer;
    margin-left: 10px;
  }
  .newList{
  }
  .newList .title{
    height: 46px;
    line-height: 46px;
    padding: 0 35px;
    background: #5680f9;
    color: #ffffff;
    font-size: 17px;
  }
  .newList ul{
    width: 1233px;
    margin-left: -33px;
    overflow: hidden;
    padding-bottom: 30px;
  }
  .newList ul li{
    float: left;
    width: 378px;
    height: 203px;
    margin: 12px 0 0 33px;
    position: relative;
  }
  .newList img{
    width: 100%;
    height: 100%;
  }
  .newList .slogin{
    position: absolute;
    top: 11px;
    left: 11px;
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    color: #ffffff;
    border-radius: 32px;
    padding: 0 18px;
    background: rgba(0,0,0,0.5);
  }
  .newList .info{
    position: absolute;
    width: 318px;
    padding: 0 30px;
    right: 0px;
    bottom: 0px;
    height: 67px;
    background: rgba(0,0,0,0.5);
    color: #ffffff;
  }
  .newList .info .des{
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .newList .info .price{
    height: 30px;
    line-height: 30px;
    font-size: 13px;
  }
  .newList .info .price p{
    float: left;
  }
  .newList .info .price p+p{
    float: right;
    font-size: 32px;
    color: #ffcd30;
  }
  .newList .info .price p+p span{
    font-size: 18px;
    margin-right: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/activitys.vue